import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddVenueLayer from "../components/AddVenueLayer";
import { useParams } from "react-router-dom";

const EditVenuePage = () => {
    const { id } = useParams();
    
    return (
        <MasterLayout>
            <Breadcrumb title="Edit Venue" />
            <AddVenueLayer venueId={id} />
        </MasterLayout>
    );
};

export default EditVenuePage;
